<template>
  <span
    class="tw-inline-flex tw-items-center tw-justify-center tw-leading-none"
    :style="{ width: `${width}px`, height: `${height}px` }"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      :width="width"
      :height="height"
      :viewBox="viewBox"
      fill="none"
      aria-hidden="true"
    >
      <path :d="path" :fill="fillColor" />
    </svg>
  </span>
</template>
<script>
import {
  PROPERTY_TYPE_ICON_PATHS,
  PROPERTY_TYPE_ICON_VIEW_BOX,
} from '@components/Property/MobileSearchFilters/constants.ts';

export default {
  name: 'PropertyTypeIcon',
  props: {
    type: {
      type: String,
      required: true,
      validator: (value) => value in PROPERTY_TYPE_ICON_PATHS,
    },
    width: {
      type: Number,
      default: 18,
    },
    height: {
      type: Number,
      default: 18,
    },
    fillColor: {
      type: String,
      default: 'currentColor',
    },
  },
  computed: {
    viewBox() {
      return PROPERTY_TYPE_ICON_VIEW_BOX;
    },
    path() {
      return PROPERTY_TYPE_ICON_PATHS[this.type];
    },
  },
};
</script>
